import { useState } from 'react';

const INITIAL = {
  business_name: '',
  contact_person: '',
  business_email: '',
  business_phone: '',
  service_category: '',
  service_area: '',
  website: '',
  lead_method: '',
  best_fit_jobs: '',
  business_contact_consent: false,
  lead_sharing_acknowledgement: false,
  license_acknowledgement: false,
  insurance_acknowledgement: false,
};

export default function BusinessRegistrationForm() {
  const [form, setForm] = useState(INITIAL);
  const [submitted, setSubmitted] = useState(false);
  const [buttonText, setButtonText] = useState('Register business');

  function onChange(e) {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }

  function onSubmit(e) {
    e.preventDefault();
    const body = new URLSearchParams({ 'form-name': 'business-registration', ...form });
    fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body })
      .then(() => {
        setSubmitted(true);
        setButtonText('Request captured');
        setTimeout(() => {
          setSubmitted(false);
          setButtonText('Register business');
        }, 2600);
        setForm(INITIAL);
      })
      .catch(() => alert('Something went wrong. Please try again.'));
  }

  return (
    <form
      name="business-registration"
      method="POST"
      data-netlify="true"
      netlify-honeypot="bot-field"
      className={`quote-form business-form reveal delay-1${submitted ? ' submitted' : ''}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="form-name" value="business-registration" />
      <p className="hidden"><label>Do not fill this out: <input name="bot-field" /></label></p>

      <div className="form-row two">
        <label>Business name
          <input name="business_name" autoComplete="organization" required placeholder="Your business name" value={form.business_name} onChange={onChange} />
        </label>
        <label>Contact person
          <input name="contact_person" autoComplete="name" required placeholder="Full name" value={form.contact_person} onChange={onChange} />
        </label>
      </div>

      <div className="form-row two">
        <label>Business email
          <input name="business_email" type="email" autoComplete="email" required placeholder="business@example.com" value={form.business_email} onChange={onChange} />
        </label>
        <label>Business phone
          <input name="business_phone" type="tel" autoComplete="tel" required placeholder="Business phone number" value={form.business_phone} onChange={onChange} />
        </label>
      </div>

      <div className="form-row two">
        <label>Service categories
          <select name="service_category" required value={form.service_category} onChange={onChange}>
            <option value="">Choose main category</option>
            <option>Movers</option>
            <option>Cleaning</option>
            <option>Handyman / furniture assembly</option>
            <option>Painting</option>
            <option>Internet / mobile setup</option>
            <option>Licensed insurance partner</option>
            <option>Other local service</option>
          </select>
        </label>
        <label>Service area
          <input name="service_area" required placeholder="Cities / neighbourhoods served" value={form.service_area} onChange={onChange} />
        </label>
      </div>

      <div className="form-row two">
        <label>Website or social profile
          <input name="website" type="url" placeholder="https://..." value={form.website} onChange={onChange} />
        </label>
        <label>Preferred lead method
          <select name="lead_method" required value={form.lead_method} onChange={onChange}>
            <option value="">Select one</option>
            <option>Email</option>
            <option>Phone</option>
            <option>Both</option>
          </select>
        </label>
      </div>

      <label>Best-fit jobs
        <textarea name="best_fit_jobs" rows="5" placeholder="Tell us what you offer, preferred job sizes, availability, and any areas you do not serve." value={form.best_fit_jobs} onChange={onChange} />
      </label>

      <label className="check">
        <input name="business_contact_consent" type="checkbox" required checked={form.business_contact_consent} onChange={onChange} />
        <span>I consent to Quoteramaa collecting my business registration details and contacting me about early access, customer requests, and platform updates.</span>
      </label>

      <label className="check">
        <input name="lead_sharing_acknowledgement" type="checkbox" required checked={form.lead_sharing_acknowledgement} onChange={onChange} />
        <span>I understand Quoteramaa may share relevant customer request details with my business only when the request appears to match my service category and coverage area.</span>
      </label>

      <label className="check">
        <input name="license_acknowledgement" type="checkbox" required checked={form.license_acknowledgement} onChange={onChange} />
        <span>I confirm my business is responsible for maintaining any required licenses, permits, insurance, registrations, and professional approvals for the services I offer.</span>
      </label>

      <label className="check">
        <input name="insurance_acknowledgement" type="checkbox" checked={form.insurance_acknowledgement} onChange={onChange} />
        <span>If registering as an insurance partner, I confirm that insurance-related services will be handled only by appropriately licensed professionals.</span>
      </label>

      <button className="btn primary" type="submit">{buttonText}</button>
      <p className="success">Registration received. We'll review your details and contact you before sending any customer requests.</p>
    </form>
  );
}
